var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    fill: "#f3f3f3",
    stroke: "#002173",
    strokeWidth: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "none",
    stroke: "#002173",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.681,37.539a1.772,1.772,0,0,1-.832-.209l-10.2-5.366L9.44,37.33a1.772,1.772,0,0,1-.832.209,1.794,1.794,0,0,1-1.372-.645,1.751,1.751,0,0,1-.388-1.447L8.8,24.087.541,16.047A1.785,1.785,0,0,1,1.529,13l11.41-1.669L18.043.995a1.786,1.786,0,0,1,3.2,0l5.1,10.337L37.76,13a1.786,1.786,0,0,1,.988,3.046l-8.257,8.041,1.949,11.36a1.75,1.75,0,0,1-.388,1.447A1.8,1.8,0,0,1,30.681,37.539ZM19.644,28.161a1.8,1.8,0,0,1,.832.205l7.832,4.118-1.5-8.719a1.787,1.787,0,0,1,.515-1.58l6.338-6.174L24.9,14.731a1.781,1.781,0,0,1-1.343-.977L19.645,5.819l-3.917,7.934a1.781,1.781,0,0,1-1.343.977l-8.761,1.28,6.338,6.174a1.786,1.786,0,0,1,.513,1.58l-1.5,8.719,7.834-4.118A1.792,1.792,0,0,1,19.644,28.161Z",
    transform: "translate(20.356 20)",
    fill: "#f0b33f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout1);
export default __webpack_public_path__ + "static/media/about1.66df044e132259a8eb61bee55a356003.svg";
export { ForwardRef as ReactComponent };